<div class="avatar">
  <mat-icon color="primary" *ngIf="avatar && avatar.length == 0">{{ getIcon(gender) }}</mat-icon>
  <img [src]="avatar" *ngIf="avatar && avatar.length > 0" />
</div>